import script from "./DateOfBirthInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./DateOfBirthInput.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__